export default "__VITE_ASSET__CCKfDcFc__"